import React from 'react'
import { useConfig } from "@revenuewell/logic-config"
import { useOidc } from '@revenuewell/logic-oidc'
import { useNotification } from '@revenuewell/logic-notification'
import { VirtualVisitContext } from './context'
import VirtualVisitService from '../../services/virtual-visit/virtual-visit-service'
import { VirtualVisit } from './types'

export function VirtualVisitProvider(props: React.PropsWithChildren<unknown>) {
  const { config } = useConfig()
  const { oidcService } = useOidc()
  const { showError } = useNotification()
  const virtualVisitService = new VirtualVisitService(config, oidcService)

  const startVirtualVisit = async (customerUserId: number, locationId: number, contactId: number): Promise<VirtualVisit> => {
    if (!config.virtualVisits || !config.virtualVisits.apiUrl)
      showError("config.json - virtualVisits.apiUrl entry is missing")

    const room = await virtualVisitService.startRoom(customerUserId, locationId, contactId)
    const links = await virtualVisitService.getLinks(room.roomNumber)

    return { room, links }
  }

  return <VirtualVisitContext.Provider value={{ startVirtualVisit }}>
    {props.children}
  </VirtualVisitContext.Provider>
}